import(/* webpackMode: "eager" */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/src/app/components/sections/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/src/layouts/AdquiraPage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/src/layouts/Default/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/src/layouts/Documentation/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/_work/stone-site-front-end/stone-site-front-end/src/layouts/shared/Footer/index.tsx");
